/**
 * Scoreboard Font Configuration
 *
 * Defines both local fonts (from src/fonts) and Google Fonts available for selection.
 * Local fonts are loaded via @font-face, Google Fonts are loaded dynamically.
 */

export interface IFontOption {
  value: string;
  label: string;
  type: 'local' | 'google';
  /** CSS font-family value */
  family: string;
}

/**
 * Local fonts available in src/fonts/
 * Add @font-face declarations in fonts.css for these
 */
export const LOCAL_FONTS: IFontOption[] = [
  {
    value: 'all-prosans',
    label: 'All-ProSans (Local)',
    type: 'local',
    family: 'All-ProSans',
  },
  {
    value: 'all-pro-display-a',
    label: 'All Pro Display A (Local)',
    type: 'local',
    family: 'All Pro Display A',
  },
  {
    value: 'nunito-sans',
    label: 'Nunito Sans (Local)',
    type: 'local',
    family: 'Nunito Sans',
  },
  {
    value: 'roboto-local',
    label: 'Roboto (Local)',
    type: 'local',
    family: 'Roboto',
  },
];

/**
 * Google Fonts loaded dynamically
 */
export const GOOGLE_FONTS: IFontOption[] = [
  { value: 'inter', label: 'Inter', type: 'google', family: 'Inter' },
  { value: 'open-sans', label: 'Open Sans', type: 'google', family: 'Open Sans' },
  { value: 'montserrat', label: 'Montserrat', type: 'google', family: 'Montserrat' },
  { value: 'poppins', label: 'Poppins', type: 'google', family: 'Poppins' },
  { value: 'oswald', label: 'Oswald', type: 'google', family: 'Oswald' },
  { value: 'bebas-neue', label: 'Bebas Neue', type: 'google', family: 'Bebas Neue' },
  { value: 'anton', label: 'Anton', type: 'google', family: 'Anton' },
  { value: 'barlow-condensed', label: 'Barlow Condensed', type: 'google', family: 'Barlow Condensed' },
  { value: 'rubik', label: 'Rubik', type: 'google', family: 'Rubik' },
];

/**
 * All available fonts for the dropdown
 */
export const ALL_FONTS: IFontOption[] = [
  { value: '', label: 'Default (System)', type: 'local', family: '' },
  ...LOCAL_FONTS,
  ...GOOGLE_FONTS,
];

/**
 * Get font option by family name
 */
export const getFontByFamily = (family: string): IFontOption | undefined => {
  return ALL_FONTS.find(f => f.family === family);
};

/**
 * Get font option by value
 */
export const getFontByValue = (value: string): IFontOption | undefined => {
  return ALL_FONTS.find(f => f.value === value);
};